<div class="progress-bar shine" [ngClass]="{ 'stripes': stripes}">
  <span [ngStyle]="{ 'width': progress + '%' }"></span>
</div>
